import React, { useState } from 'react';
import './StyleGallery.css';
import { approvedStyles } from '../data/approvedStyles';

const StyleGallery: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [hoveredStyle, setHoveredStyle] = useState<string | null>(null);

  const categories = [
    { id: 'all', name: 'All Styles', icon: '✨' },
    { id: 'professional', name: 'Professional', icon: '💼' },
    { id: 'artistic', name: 'Artistic', icon: '🎨' },
    { id: 'fantasy', name: 'Fantasy', icon: '🦄' },
    { id: 'futuristic', name: 'Futuristic', icon: '🚀' },
    { id: 'vintage', name: 'Vintage', icon: '📷' },
    { id: 'creative', name: 'Creative', icon: '🌟' }
  ];

  const filteredStyles = selectedCategory === 'all' 
    ? approvedStyles 
    : approvedStyles.filter(style => style.category === selectedCategory);

  return (
    <section id="style-gallery" className="style-gallery-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Explore Our Style Collection</h2>
          <p className="section-subtitle">
            56+ professionally crafted AI portrait styles to match every mood and occasion
          </p>
        </div>

        <div className="category-filters">
          {categories.map(category => (
            <button
              key={category.id}
              className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.id)}
            >
              <span className="category-icon">{category.icon}</span>
              <span className="category-name">{category.name}</span>
            </button>
          ))}
        </div>

        <div className="styles-grid">
          {filteredStyles.map(style => (
            <div
              key={style.id}
              className="style-card"
              onMouseEnter={() => setHoveredStyle(style.id)}
              onMouseLeave={() => setHoveredStyle(null)}
            >
              <div className="style-image-container">
                <img 
                  src={style.thumbnail} 
                  alt={style.name}
                  className="style-thumbnail"
                />
                {hoveredStyle === style.id && (
                  <div className="style-overlay">
                    <p className="style-description">{style.description}</p>
                    <button className="try-style-btn">Try This Style</button>
                  </div>
                )}
              </div>
              <h3 className="style-name">{style.name}</h3>
            </div>
          ))}
        </div>

        <div className="gallery-cta">
          <p className="cta-text">Ready to transform your photos?</p>
          <button className="cta-button">Download App & Start Creating</button>
        </div>
      </div>
    </section>
  );
};

export default StyleGallery;